export const planLabels: Record<string, { label: string; color: string; bg: string }> = {
  free: { label: "免费版", color: "text-gray-600", bg: "bg-gray-100" },
  basic: { label: "基础版", color: "text-blue-600", bg: "bg-blue-50" },
  pro: { label: "专业版", color: "text-orange-600", bg: "bg-orange-50" },
  enterprise: { label: "企业版", color: "text-red-600", bg: "bg-red-50" },
};

export interface TenantSite {
  id: string;
  name: string;
  subdomain: string;
  domains: string[];
  status: "active" | "suspended" | "expired";
  createdAt: string;
  expireAt: string;
  plan: "free" | "basic" | "pro" | "enterprise";
  siteType: "classified" | "mall" | "anime" | "music";
  userId?: string;
  isDefault?: boolean;
}

export const siteTypeLabels: Record<TenantSite["siteType"], { label: string; color: string; bg: string }> = {
  classified: { label: "分类信息网站", color: "text-emerald-600", bg: "bg-emerald-50" },
  mall: { label: "多商户商城", color: "text-amber-600", bg: "bg-amber-50" },
  anime: { label: "动漫网站", color: "text-rose-600", bg: "bg-rose-50" },
  music: { label: "音乐网站", color: "text-cyan-600", bg: "bg-cyan-50" },
};

export const tenantAccount = {
  id: "tenant-1",
  name: "商服汇总部",
  username: "admin",
  plan: "enterprise" as const,
  expireAt: "2026-12-31T23:59:59Z",
  maxSites: 20,
  usedSites: 4,
  balance: 12800,
};

export const tenantSites: TenantSite[] = [
  {
    id: "site-1",
    name: "商服汇主站",
    subdomain: "main",
    domains: ["www.shangfuhui.com"],
    status: "active",
    createdAt: "2025-01-15T08:00:00Z",
    expireAt: "2026-12-31T23:59:59Z",
    plan: "enterprise",
    siteType: "classified",
    userId: "u-1",
    isDefault: true,
  },
  {
    id: "site-2",
    name: "北京分站",
    subdomain: "beijing",
    domains: ["bj.shangfuhui.com"],
    status: "active",
    createdAt: "2025-03-20T10:00:00Z",
    expireAt: "2026-12-31T23:59:59Z",
    plan: "pro",
    siteType: "mall",
    userId: "u-2",
  },
  {
    id: "site-3",
    name: "上海分站",
    subdomain: "shanghai",
    domains: ["sh.shangfuhui.com", "shanghai.shangfuhui.com"],
    status: "active",
    createdAt: "2025-05-10T14:30:00Z",
    expireAt: "2026-12-31T23:59:59Z",
    plan: "pro",
    siteType: "anime",
    userId: "u-3",
  },
  {
    id: "site-4",
    name: "测试站点",
    subdomain: "test",
    domains: [],
    status: "suspended",
    createdAt: "2025-08-01T09:00:00Z",
    expireAt: "2026-03-01T23:59:59Z",
    plan: "free",
    siteType: "music",
    userId: "u-4",
  },
  {
    id: "site-5",
    name: "广州分站",
    subdomain: "guangzhou",
    domains: ["gz.shangfuhui.com"],
    status: "active",
    createdAt: "2025-09-15T11:00:00Z",
    expireAt: "2026-12-31T23:59:59Z",
    plan: "basic",
    siteType: "classified",
    userId: "u-5",
  },
  {
    id: "site-6",
    name: "深圳分站",
    subdomain: "shenzhen",
    domains: [],
    status: "expired",
    createdAt: "2025-01-01T00:00:00Z",
    expireAt: "2026-01-01T00:00:00Z",
    plan: "free",
    siteType: "mall",
    userId: "u-6",
  },
  {
    id: "site-7",
    name: "动漫视界",
    subdomain: "animeview",
    domains: ["animeview.shangfuhui.com"],
    status: "active",
    createdAt: "2025-06-20T08:30:00Z",
    expireAt: "2026-12-31T23:59:59Z",
    plan: "pro",
    siteType: "anime",
    userId: "u-7",
  },
  {
    id: "site-8",
    name: "音乐坊",
    subdomain: "musicfang",
    domains: ["music.shangfuhui.com"],
    status: "suspended",
    createdAt: "2025-07-10T14:00:00Z",
    expireAt: "2026-04-01T23:59:59Z",
    plan: "free",
    siteType: "music",
    userId: "u-8",
  },
];

export interface TenantUser {
  id: string;
  username: string;
  password: string;
  phone: string;
  companyName?: string;
  siteQuota: {
    classified: number;
    mall: number;
    anime: number;
    music: number;
  };
  status: "active" | "expired" | "disabled";
  createdAt: string;
  expireAt: string;
}

export const tenantUsers: TenantUser[] = [
  {
    id: "u-1",
    username: "zhangsan",
    password: "******",
    phone: "13800138001",
    companyName: "北京科技有限公司",
    siteQuota: { classified: 3, mall: 1, anime: 0, music: 0 },
    status: "active",
    createdAt: "2025-01-10T09:00:00Z",
    expireAt: "2026-12-31T23:59:59Z",
  },
  {
    id: "u-2",
    username: "lisi",
    password: "******",
    phone: "13800138002",
    companyName: "上海信息咨询",
    siteQuota: { classified: 2, mall: 0, anime: 0, music: 0 },
    status: "active",
    createdAt: "2025-03-15T10:30:00Z",
    expireAt: "2026-12-31T23:59:59Z",
  },
  {
    id: "u-3",
    username: "wangwu",
    password: "******",
    phone: "13800138003",
    siteQuota: { classified: 1, mall: 1, anime: 1, music: 0 },
    status: "active",
    createdAt: "2025-05-20T14:00:00Z",
    expireAt: "2026-12-31T23:59:59Z",
  },
  {
    id: "u-4",
    username: "testuser",
    password: "******",
    phone: "13800138004",
    siteQuota: { classified: 0, mall: 0, anime: 0, music: 0 },
    status: "expired",
    createdAt: "2024-08-01T09:00:00Z",
    expireAt: "2025-03-01T23:59:59Z",
  },
  {
    id: "u-5",
    username: "guangzhou_user",
    password: "******",
    phone: "13800138005",
    companyName: "广州贸易公司",
    siteQuota: { classified: 2, mall: 1, anime: 0, music: 0 },
    status: "active",
    createdAt: "2025-09-01T11:00:00Z",
    expireAt: "2026-09-01T23:59:59Z",
  },
  {
    id: "u-6",
    username: "disabled_user",
    password: "******",
    phone: "13800138006",
    siteQuota: { classified: 0, mall: 0, anime: 0, music: 0 },
    status: "disabled",
    createdAt: "2024-01-01T00:00:00Z",
    expireAt: "2026-01-01T00:00:00Z",
  },
  {
    id: "u-7",
    username: "anime_fan",
    password: "******",
    phone: "13800138007",
    companyName: "二次元文化传播有限公司",
    siteQuota: { classified: 0, mall: 0, anime: 5, music: 0 },
    status: "active",
    createdAt: "2025-06-15T08:30:00Z",
    expireAt: "2026-12-31T23:59:59Z",
  },
  {
    id: "u-8",
    username: "music_lover",
    password: "******",
    phone: "13800138008",
    siteQuota: { classified: 0, mall: 0, anime: 0, music: 2 },
    status: "disabled",
    createdAt: "2025-07-05T13:00:00Z",
    expireAt: "2026-04-01T23:59:59Z",
  },
  {
    id: "u-9",
    username: "hangzhou_user",
    password: "******",
    phone: "13800138009",
    companyName: "杭州电子商务",
    siteQuota: { classified: 1, mall: 2, anime: 0, music: 1 },
    status: "active",
    createdAt: "2025-10-01T10:00:00Z",
    expireAt: "2026-10-01T23:59:59Z",
  },
  {
    id: "u-10",
    username: "chengdu_user",
    password: "******",
    phone: "13800138010",
    companyName: "成都科技有限公司",
    siteQuota: { classified: 4, mall: 3, anime: 2, music: 1 },
    status: "active",
    createdAt: "2025-02-15T09:30:00Z",
    expireAt: "2026-12-31T23:59:59Z",
  },
  {
    id: "u-11",
    username: "expired_user1",
    password: "******",
    phone: "13800138011",
    siteQuota: { classified: 0, mall: 0, anime: 0, music: 0 },
    status: "expired",
    createdAt: "2024-05-01T00:00:00Z",
    expireAt: "2025-01-01T00:00:00Z",
  },
  {
    id: "u-12",
    username: "disabled_user2",
    password: "******",
    phone: "13800138012",
    siteQuota: { classified: 0, mall: 0, anime: 0, music: 0 },
    status: "disabled",
    createdAt: "2024-06-01T00:00:00Z",
    expireAt: "2025-06-01T00:00:00Z",
  },
];

export interface TenantPlan {
  id: string;
  name: string;
  price: number;
  periodDays: number;
  siteLimits: {
    classified: number;
    mall: number;
    anime: number;
    music: number;
  };
  description?: string;
}

export const tenantPlans: TenantPlan[] = [
  {
    id: "plan-free",
    name: "免费版",
    price: 0,
    periodDays: 365,
    siteLimits: { classified: 1, mall: 0, anime: 0, music: 0 },
    description: "适合个人用户入门体验",
  },
  {
    id: "plan-basic",
    name: "基础版",
    price: 199,
    periodDays: 365,
    siteLimits: { classified: 2, mall: 1, anime: 0, music: 0 },
    description: "适合小型商户，支持基础商城",
  },
  {
    id: "plan-pro",
    name: "专业版",
    price: 599,
    periodDays: 365,
    siteLimits: { classified: 5, mall: 3, anime: 2, music: 1 },
    description: "适合中型企业，支持多种站点类型",
  },
  {
    id: "plan-enterprise",
    name: "企业版",
    price: 1999,
    periodDays: 365,
    siteLimits: { classified: 10, mall: 8, anime: 5, music: 3 },
    description: "适合大型企业，全类型不限量建设",
  },
];